

<div class="row" *ngIf="form && selectedDeliveryLocation">
  <div class="col-12">
    <div class="form-group">
      <label for="deliveryLocation" class="control-label" translate>DELIVERY_LOCATION</label>
      <select name="deliveryLocation" id="deliveryLocation" class="form-control form-select" [(ngModel)]="deliveryLocationId">
        <option [value]="option.id" *ngFor="let option of deliveryLocations; let first = first">
          {{ first ? ('CUSTOMER_ADDRESS' | translate) : option.name }}
        </option>
      </select>
    </div>
  </div>

  <div class="col-12 col-md-6">
    <fieldset disabled>
    <div class="form-group" [formGroup]="form">
      <label for="ordlevadr1" class="control-label" translate>OH_ORDLEVADR1</label>
      <input class="form-control" type="text" name="ordlevadr1" id="ordlevadr1" [formControlName]="'ordlevadr1'" />
    </div>
    <div class="form-group" [formGroup]="form">
      <label for="ordlevadr2" class="control-label" translate>OH_ORDLEVADR2</label>
      <input class="form-control" type="text" name="ordlevadr2" id="ordlevadr2" [formControlName]="'ordlevadr2'" />
    </div>
    <div class="form-group" [formGroup]="form">
      <label for="ordlevadr3" class="control-label" translate>OH_ORDLEVADR3</label>
      <input class="form-control" type="text" name="ordlevadr3" id="ordlevadr3" [formControlName]="'ordlevadr3'" />
    </div>
    <div class="form-group">
      <label for="postalCode" class="control-label" translate>OH_FTGPOSTNR</label>
      <input class="form-control" type="text" name="postalCode" id="postalCode" [(ngModel)]="postalCode" />
    </div>
    <div class="form-group">
      <label for="city" class="control-label" translate>OH_ORDLEVADR4</label>
      <input class="form-control" type="text" name="city" id="city" [(ngModel)]="city" />
    </div>
    <div [formGroup]="form">
      <lib-meta-select-input formControlName="ordlevadrlandskod" table="xr" metaId="landskod" metaDisplay="land">
      </lib-meta-select-input>
    </div>
    </fieldset>
  </div>
  <div class="col-12 col-md-6">
    <lib-confirmation-emails
      [emails]="checkout.extra.confirmationEmails"
      (emailsUpdated)="checkout.extra.confirmationEmails = $event"
    ></lib-confirmation-emails>
    <div class="form-group mb-0" [formGroup]="formOh">
      <label for="kundbestnr" class="control-label" translate>OH_KUNDBESTNR</label>
      <input class="form-control" type="text" name="kundbestnr" id="kundbestnr" formControlName="kundbestnr" />
    </div>
    <div
      *ngIf="formOh.get('kundbestnr').invalid && (formOh.get('kundbestnr').dirty || formOh.get('kundbestnr').touched)"
      class="alert alert-danger"
    >
      <span translate>FORM_ERROR_REQUIRED</span>
    </div>
    <div class="form-group mb-0" [formGroup]="formOh">
      <label for="kundref2" class="control-label" translate>OH_KUNDREF2</label>
      <input class="form-control" type="text" name="kundref2" id="kundref2" formControlName="kundref2" />
    </div>
    <div
      *ngIf="formOh.get('kundref2').invalid && (formOh.get('kundref2').dirty || formOh.get('kundref2').touched)"
      class="alert alert-danger"
    >
      <span translate>FORM_ERROR_REQUIRED</span>
    </div>
    <div class="form-group" [formGroup]="formOh">
      <label for="q_internal_notes" lass="control-label" translate>MESSAGE</label>
      <textarea
        class="form-control"
        type="text"
        name="q_internal_notes"
        id="q_internal_notes"
        rows="6"
        formControlName="q_internal_notes"
      ></textarea>
    </div>
  </div>

  <div class="col-12">
    <div *ngIf="productsMap && pricesMap">
        <h4 translate>ROWS</h4>
        <div class="row">
          <div class="col-12 table-responsive gung-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th translate>PRODUCT_ID</th>
                  <th translate>NAME</th>
                  <th translate>ESTIMATED_DELIVERY_DATE</th>
                  <th translate>QUANTITY</th>
                  <th translate>UNIT_PRICE</th>
                  <!-- <th *ngIf="sales" class="d-table-cell" translate>DISCOUNT</th> -->
                  <th translate>TOTAL</th>
                  <!-- <th translate>TOTAL_AFTER_DISCOUNT</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of checkout.rows">
                  @if (row.id !== '46607-03') {
                    <td [attr.data-label]="'PRODUCT_ID' | translate">{{ row.id }}</td>
                    <td [attr.data-label]="'NAME' | translate">{{ productsMap[row.id].name }}</td>
                    <td [attr.data-label]="'ESTIMATED_DELIVERY_DATE' | translate">
                      <span *ngIf="row.extra.orp && row.extra.orp.ordberlevdat; else orderHeadDate">{{
                        row.extra.orp.ordberlevdat | date: dateUtilService.dateFormat
                      }}</span>
                      <ng-template #orderHeadDate>
                        <span *ngIf="checkout.extra.oh.ordberlevdat; else defaultDate">{{
                          checkout.extra.oh.ordberlevdat | date: dateUtilService.dateFormat
                        }}</span>
                      </ng-template>
                      <ng-template #defaultDate>{{ today | date: dateUtilService.dateFormat }}</ng-template>
                    </td>
                    <td [attr.data-label]="'QUANTITY' | translate">{{ row.quantity }}</td>
                    <td [attr.data-label]="'UNIT_PRICE' | translate">
                      @if(pricesMap?.[row.id]){
                        <lib-price [price]="pricesMap[row.id]" type="NET"></lib-price>
                      }
                      
                      <!-- <span *ngIf="pricesMap">
                        <lib-price [price]="pricesMap[row.id]" type="cartRowUnitPrice"></lib-price>
                      </span> -->
                    </td>
                    <!-- <td [attr.data-label]="'DISCOUNT' | translate" *ngIf="sales" class="d-table-cell">
                      <span *ngIf="pricesMap && pricesMap[row.id].cartRowDiscountPercent"
                        >{{ pricesMap[row.id].cartRowDiscountPercent | number: '1.0-2' }} %</span
                      >
                    </td> -->
                    <td [attr.data-label]="'TOTAL' | translate">
                      <span *ngIf="pricesMap">
                        @if(pricesMap?.[row.id]){
                          <lib-price [price]="(pricesMap?.[row.id].customerNetPrice.value * row.quantity)"></lib-price>
                        }
                        
                      </span>
                    </td>
                    <!-- <td>
                      @if(row.extra?.orp?.vb_pris){
                        <lib-price [price]="(row.extra.orp.vb_pris * row.quantity) - ((row.extra.orp.vb_pris * row.quantity) * (pricesMap[row.id].cartRowDiscountPercent / 100))"></lib-price>
                      }
                    </td> -->
                    <!-- <td *ngIf="pricesMap">{{pricesMap[row.id].customerNetPrice.value}} {{pricesMap[row.id].customerNetPrice.currencyCode}}</td> -->
                  }
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>
</div>

<!--
    oh.ordberlevdat // Leverans datum TODO-AL
 -->
